
import { Component, Vue } from 'vue-property-decorator'
import venueModule from '@/store/venue'
import VenueEditor from '@/components/company/venue/VenueEditor.vue'
import BeaconDealEditor from '@/components/company/deal/BeaconDealEditor.vue'

import { Venue } from '@/types/Company'

@Component({
  name: 'CompanyList',
  components: {
    VenueEditor,
    BeaconDealEditor
  }
})
class CompanyDetail extends Vue {
  private showBeaconManager = false

  private get venue() {
    return venueModule.venue
  }

  private get headers() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Stadt', value: 'address.city' },
      { text: 'Status', value: 'enable' }
    ]
  }

  private async created(): Promise<void> {
    if (!this.venue) {
      await venueModule.fetch(this.$route.params.vid)
    }
  }

  private setVenue(venue: Venue): void {
    venueModule.setVenue(venue)
  }
}

export default CompanyDetail
